import { render } from "./GestioneTimbrature.vue?vue&type=template&id=8dea600e&scoped=true"
import script from "./GestioneTimbrature.vue?vue&type=script&lang=js"
export * from "./GestioneTimbrature.vue?vue&type=script&lang=js"

import "./GestioneTimbrature.vue?vue&type=style&index=0&id=8dea600e&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dea600e"]])

export default __exports__